import React from "react";
import "./ComplianceWarning.scss";

const groupByPolicy = (violations) => {
  const groups = new Map();
  violations.forEach((v) => {
    const key = v.policyKey || "other";
    if (!groups.has(key)) {
      groups.set(key, {
        policyKey: key,
        policyLabel: v.policyLabel || "Other policy",
        policyUrl: v.policyUrl || null,
        items: [],
      });
    }
    groups.get(key).items.push(v);
  });
  return Array.from(groups.values());
};

const ComplianceWarning = ({
  severity,
  violations,
  blockHeading = "This message can't be sent",
  warnHeading = "Heads up before you send",
  footerText = "You may proceed at your discretion. This is not legal advice.",
}) => {
  if (!Array.isArray(violations) || violations.length === 0) return null;
  if (severity !== "block" && severity !== "warn") return null;

  const isBlock = severity === "block";
  const groups = groupByPolicy(violations);

  return (
    <div
      className={`compliance-warning compliance-warning--${severity}`}
      role={isBlock ? "alert" : "status"}
      aria-live={isBlock ? "assertive" : "polite"}
    >
      <div className="compliance-warning__icon" aria-hidden="true">
        {isBlock ? (
          <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" />
          </svg>
        ) : (
          <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
            <path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z" />
          </svg>
        )}
      </div>
      <div className="compliance-warning__body">
        <p className="compliance-warning__heading">
          {isBlock ? blockHeading : warnHeading}
        </p>
        {groups.map((group) => (
          <div key={group.policyKey} className="compliance-warning__group">
            <p className="compliance-warning__group-label">
              {group.policyUrl ? (
                <a
                  href={group.policyUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="compliance-warning__policy-link"
                >
                  {group.policyLabel}
                </a>
              ) : (
                group.policyLabel
              )}
            </p>
            <ul className="compliance-warning__list">
              {group.items.map((v, i) => (
                <li
                  key={`${v.category}-${i}`}
                  className="compliance-warning__item"
                >
                  <span className="compliance-warning__quote">
                    &ldquo;{v.text}&rdquo;
                  </span>
                  <span className="compliance-warning__sep"> - </span>
                  <span className="compliance-warning__reason">{v.reason}</span>
                </li>
              ))}
            </ul>
          </div>
        ))}
        <p className="compliance-warning__guidance">{footerText}</p>
      </div>
    </div>
  );
};

export default ComplianceWarning;
